<template>
    <div class="c-view">
        <InternalHeader>
            <div slot="title" class="c-internal-header__title">
                {{ $t("pageTitles.changePassword") }}
            </div>
        </InternalHeader>
        <Row class="mt-5" :gutter="16">
            <Col span="12"
                ><password-form
                    :loading="loading"
                    @submit="handleSubmit"
                ></password-form
            ></Col>
        </Row>
    </div>
</template>

<script>
export default {
    props: {
        mePasswordRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/me-password.js"))();
            },
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    components: {
        InternalHeader: function() {
            return import("@/js/components/partials/header");
        },
        PasswordForm: () => {
            return import("@/js/components/partials/password-form");
        },
    },
    methods: {
        async handleSubmit(formData) {
            var _this = this;
            var data = {
                password_existing: formData.passwordExisting,
                password_new: formData.passwordNew,
            };

            this.loading = true;

            try {
                var response = await this.mePasswordRepository.update(data);
            } catch (e) {
                this.loading = false;
                return;
            }

            this.$Message.success({
                content: "Password updated.",
            });

            this.loading = false;
        },
    },
};
</script>
